import { PERCEPTION_CONTENT } from './perceptionContent';
import { perceptionRowFor, withVoucherClaim } from './perceptionRows';
import { usePerceptionEnabled } from './usePerceptionPricing';
import { useVoucherEligibleTld } from './useVoucherEligibleTld';
export const usePerceptionTldRow = (pricing, tld) => {
  const enabled = usePerceptionEnabled();
  const isVoucherEligible = useVoucherEligibleTld(enabled);
  if (!enabled) {
    return undefined;
  }
  return withVoucherClaim(perceptionRowFor(pricing, PERCEPTION_CONTENT.businessManager), isVoucherEligible(tld));
};
//# sourceMappingURL=usePerceptionTldRow.js.map